import {Component, OnInit} from '@angular/core';
import {Photo, PhotoGallerySettings} from '../../../widgets/fancy-photo-gallery/fancy-photo-gallery/fancy-photo-classes';
import {Animal, Rarity, Entry, Entries} from '../../../widgets-module/components/animal-rarities/animal-rarities-classes';
import {TripEntry} from '../../../widgets-module/components/trip-list/trip-list.component';
import {LakeManyaraText} from "./lake-manyara.text";
import {GoogleMapStyles, Park, Point} from "../../../../google-maps-points";

@Component({
    selector: 'app-lake-manyara',
    templateUrl: './lake-manyara.component.html',
    styleUrls: ['./lake-manyara.component.css']
})
export class LakeManyaraComponent implements OnInit {

    tripEntries: TripEntry[] = [
        new TripEntry({title: 'Big Buck', route: '../../safari/big-buck-safari', iconName: 'buffalo'}),
        new TripEntry({title: 'Culture Quest', route: '../../safari/culture-quest-safari', iconName: 'drum'}),
        new TripEntry({title: 'Lion\'s Share', route: '../../safari/lions-share-safari', iconName: 'lion'})
    ];

  mapLng = 35.84004164;
  mapLat = -3.37064227;
  googleMapStyles = GoogleMapStyles; // pull from the global export

  zoom = 9; // default zoom level of the map
  circleWidthsDesktop = ['2rem', '3rem', '4rem', '4rem', '5.5rem'];
  circleWidthsMobile = ['2.5rem', '3.75rem', '4.75rem', '5rem', '6.5rem'];

  parkText = new LakeManyaraText();

    // Animal Rarity Tooltips
    animalEntries: Entries = new Entries({
        entries:
            [

                new Entry({animal: Animal.WaterBuck, rarity: Rarity.Common}),
                new Entry({animal: Animal.Elephant, rarity: Rarity.Common}),
                new Entry({animal: Animal.Baboon, rarity: Rarity.Common}),
                new Entry({animal: Animal.WaterThickKnee, rarity: Rarity.Common}),
                new Entry({animal: Animal.Hippo, rarity: Rarity.Common}),
                new Entry({animal: Animal.Zebra, rarity: Rarity.Common}),
                new Entry({animal: Animal.YellowBilledStork, rarity: Rarity.Common}),
                new Entry({animal: Animal.Jackal, rarity: Rarity.Uncommon}),
                new Entry({animal: Animal.EgyptianDuck, rarity: Rarity.Uncommon}),
                new Entry({animal: Animal.TreeClimbingLion, rarity: Rarity.Rare})
            ]
    });

    // photo gallery metadata
    storkPhoto: PhotoGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos:
            [
                new Photo({
                    title: 'Birds of Paradise',
                    description: 'These Pelicans and Yellow Billed Storks come to Lake Manyara for easy access to water and food',
                    thumbnailPath: '700x465/yellow-billed-storks.jpg',
                    highresPath: '../../assets/img/others/yellow-billed-storks.jpg',
                    altPhotoDescription: 'Adult Yellow Billed Storks Eating at Lake Manyara'
                })
            ]
    });

    elephantPhoto: PhotoGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos:
            [
                new Photo({
                    title: 'Adult Elephant on the Road',
                    description: 'An adult elephant crosses the road while looking for some cool, refreshing water.',
                    thumbnailPath: '700x525/manyara-elephant.jpg',
                    highresPath: '../../assets/img/others/manyara-elephant.jpg',
                    altPhotoDescription: 'Adult African Elephant on Safari in Lake Manyara'
                })
            ]
    });

    baboonPhoto: PhotoGallerySettings = new PhotoGallerySettings({
        iconColor: 'dark',
        photos:
            [
                new Photo({
                    title: 'Playtime!',
                    description: 'A playful bunch, this baboon family is enjoying the shade in Lake Manyara National Park.',
                    thumbnailPath: '700x525/baboon-family-manyara.jpg',
                    highresPath: '../../assets/img/others/baboon-family-manyara.jpg',
                    altPhotoDescription: 'A happy baboon toddler plays with his mom\'s tail.'
                })
            ]
    });

    parkBoundaries = [
      new Park ( {
        name: 'Lake Manyara',
        contentId: '/national-parks/lake-manyara',
        defaultColor: '#6D0068',
        hoverColor: '#460043',
        tooltipOrigin: new Point({lng: 35.84004164, lat: -3.37064227}),
        points:
          [
            new Point({lng: 35.77646255, lat: -3.43237433}),
            new Point({lng: 35.76401711, lat: -3.47024269}),
            new Point({lng: 35.7707119,  lat: -3.4830936}),
            new Point({lng: 35.75835228, lat: -3.51976056}),
            new Point({lng: 35.7329464,  lat: -3.53895017}),
            new Point({lng: 35.72629452, lat: -3.54785949}),
            new Point({lng: 35.72509289, lat: -3.55616908}),
            new Point({lng: 35.71410656, lat: -3.56387893}),
            new Point({lng: 35.70869923, lat: -3.57484395}),
            new Point({lng: 35.72414875, lat: -3.59634528}),
            new Point({lng: 35.73161602, lat: -3.63506353}),
            new Point({lng: 35.71788311, lat: -3.6670134}),
            new Point({lng: 35.72131634, lat: -3.70829813}),
            new Point({lng: 35.73135853, lat: -3.70761292}),
            new Point({lng: 35.74028492, lat: -3.70872638}),
            new Point({lng: 35.75178623, lat: -3.70658511}),
            new Point({lng: 35.77255726, lat: -3.70564294}),
            new Point({lng: 35.81409931, lat: -3.64285837}),
            new Point({lng: 35.85527658, lat: -3.47204183}),
            new Point({lng: 35.85283041, lat: -3.43605842}),
            new Point({lng: 35.85081339, lat: -3.42646262}),
            new Point({lng: 35.84763765, lat: -3.3858079}),
            new Point({lng: 35.8508563,  lat: -3.38212362}),
            new Point({lng: 35.85094213, lat: -3.37556899}),
            new Point({lng: 35.84922552, lat: -3.37325558}),
            new Point({lng: 35.84004164, lat: -3.37064227}),
            new Point({lng: 35.83450556, lat: -3.37398387}),
            new Point({lng: 35.81691027, lat: -3.38927797})
          ]})
    ];

    constructor() {
    }

    ngOnInit() {
    }

    isMobile() {
        return document.body.clientWidth < 991.98 && document.body.clientWidth > 767.98;
    }

    isMobileBr() {
        return document.body.clientWidth < 500;
    }

}
